import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fetchMetrics } from '../../../../services/metrics';
import { Card, Typography, Spinner, ErrorComponent } from '../../../../components';
import * as S from './MetricsCards.styles';
import { SOURCES } from '../../../../../constants/general.constants';
import { useParams } from 'react-router-dom';

export const MetricsCards = ({ className }) => {
	const { id: businessId } = useParams();
	const [loadingStatus, setLoadingStatus] = useState('idle');
	const [metrics, setMetrics] = useState([]);

	async function initializeData() {
		setLoadingStatus('loading');
		try {
			const {
				data: { result },
			} = await fetchMetrics({ source: SOURCES.BUSINESS, sourceId: businessId });
			setMetrics(result.metrics);
			setLoadingStatus('success');
		} catch (error) {
			setLoadingStatus('error');
		}
	}

	useEffect(() => {
		if (loadingStatus === 'idle') {
			initializeData();
		}
	}, []);

	const renderContent = () => {
		switch (loadingStatus) {
			case 'loading':
				return <Spinner />;
			case 'error':
				return <ErrorComponent />;
			case 'success':
				return (
					<>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.resourceCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Resources
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.completedRequestCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Completed Requests
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.completedBookingCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Completed Bookings
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.employeeCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Employees
							</Typography>
						</Card>
					</>
				);
			default:
				return null;
		}
	};

	return <S.CardWrapper className={className}>{renderContent()}</S.CardWrapper>;
};

MetricsCards.propTypes = {
	className: PropTypes.string,
};
